var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ESSENTIAL UI"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0C2.96254 0 0.5 2.46232 0.5 5.5C0.5 8.53768 2.96254 11 6 11C9.03746 11 11.5 8.53746 11.5 5.5C11.5 2.46254 9.03768 0 6 0Z",
    fill: "#1B84FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.05306 7.57557C7.9388 7.68979 7.78385 7.75395 7.6223 7.75395C7.46074 7.75395 7.30579 7.68979 7.19154 7.57557L5.57054 5.9535C5.51248 5.89554 5.46675 5.82643 5.43611 5.75033C5.40546 5.67423 5.39053 5.59272 5.39222 5.5107C5.39222 5.50684 5.39222 5.50318 5.39222 5.49932V1.91594C5.39222 1.75434 5.45641 1.59936 5.57068 1.4851C5.68494 1.37083 5.83992 1.30664 6.00152 1.30664C6.16311 1.30664 6.31809 1.37083 6.43235 1.4851C6.54662 1.59936 6.61081 1.75434 6.61081 1.91594V5.27029L8.05435 6.71383C8.11088 6.77048 8.15569 6.83771 8.18622 6.91169C8.21675 6.98567 8.2324 7.06494 8.23228 7.14496C8.23216 7.22499 8.21627 7.30421 8.18552 7.3781C8.15477 7.45199 8.10976 7.51909 8.05306 7.57557Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export default ForwardRef;